export const MOCK_NURSE = {
  id: 'nurse-1',
  name: 'سارة الحسن',
  nameEn: 'Sarah Al-Hassan',
  initials: 'SA',
  role: 'Registered Nurse',
  hospital: '',
  email: 'sarah.hassan@hospital.jo',
};
